import { createRenderTarget } from 'component-library/render-target'
import { breakpoints } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'
import { StyledAmpLogo, ImageLogoProps } from '../TheWestHeader.styled'
import React from 'react'

export interface LogoProps extends ImageLogoProps {
    src: string
    alt: string
}

export function createHeaderLogo(
    Component: React.ComponentType<LogoProps>,
    props: LogoProps
): React.FC<{}> {
    const HeaderLogo = createRenderTarget<{}>('HeaderLogo', {
        amp: () => {
            const { src, alt, ampInitialSize, heights } = props
            const { width, height } = ampInitialSize

            const getAmpWidthFromHeight = (value: number) => value / (height / width)

            return (
                <StyledAmpLogo
                    alt={alt}
                    src={src}
                    width={width}
                    height={height}
                    sizes={`(max-width: ${calcRem(breakpoints.xxs)}) ${calcRem(
                        getAmpWidthFromHeight(heights.mobile)
                    )}, (min-width: ${calcRem(breakpoints.xxs + 1)}) and (max-width: ${calcRem(
                        breakpoints.sm
                    )}) ${calcRem(getAmpWidthFromHeight(heights.tablet))}, ${calcRem(
                        getAmpWidthFromHeight(heights.desktop)
                    )}`}
                />
            )
        },
        web: () => <Component {...props} />,
        rss: () => <img {...props} />,
        preview: () => <Component {...props} />,
    })

    return HeaderLogo
}
